// Sélection des adresses de facturation / livraison dans un écran d'édition
// d'opération (devis, facture, vente, achat, réception, transport, broker).
//
// Les neuf écrans chargeaient deux choses : les OPTIONS du contact
// (`/person/getaddressbilling|getaddressdelivery/:idperson`) et l'adresse que
// l'opération a SÉLECTIONNÉE (`.../:idperson/:idoperation`). Trois défauts
// vivaient dans ce duo, recopiés neuf fois :
//
//   1. le repli `options[0]`. Quand l'opération n'avait aucune adresse liée, on
//      sélectionnait la PREMIÈRE adresse du contact — arbitraire, l'ordre venant
//      du SQL — et le save suivant la persistait. C'est un identifiant valide
//      mais faux : le garde serveur `resolveAddressWrite` ne peut rien contre ça,
//      il ne voit qu'un id numérique légitime. C'était le plus nuisible des trois.
//   2. l'ordre de chargement. La résolution de la sélection était lancée depuis
//      CHACUN des deux `.then()` d'options : quatre requêtes concurrentes, et la
//      première tournait contre une liste d'options encore vide.
//   3. `.then((error) => …)` suivi d'un `.catch((error) => …)` au corps
//      identique. Le premier n'est PAS un catch : il s'exécutait aussi en cas de
//      succès. Le paramètre nommé `error` le faisait passer pour une garde.
//
// Ce mixin fournit les pièces communes ; chaque écran garde ses règles métier
// (TVA bois de chauffage, numéro de facture, broker alloué, repli TVA par pays),
// mais charge désormais les options AVANT de résoudre la sélection, et propose
// via `proposeAddressOption` au lieu de piocher `options[0]`.
export default {
  data () {
    return {
      // Vrai tant qu'une requête d'adresse est en vol. Désactive les v-select et
      // le bouton Save : un enregistrement lancé dans cette fenêtre envoyait une
      // adresse nulle ou celle de l'ANCIEN contact.
      addressesLoading: false,
      addressLoadPending: 0,
      // L'opération n'a AUCUNE adresse liée en base. L'écran le dit au lieu de
      // choisir à la place de l'utilisateur.
      billingAddressUnlinked: false,
      deliveryAddressUnlinked: false
    }
  },
  methods: {
    // Quelle option correspond à l'adresse réellement liée à l'opération.
    // Injecte la sélection quand elle manque des options (adresse mal catégorisée,
    // ou liste pas encore arrivée) plutôt que de retomber sur options[0].
    pickAddressOption (options, selected) {
      if (!options || !selected || selected.value === null || selected.value === undefined) return null
      const i = options.findIndex(o => String(o.value) === String(selected.value))
      if (i >= 0) return options[i]
      options.push(selected)
      return selected
    },

    // Proposition quand l'opération n'a aucune adresse liée : l'adresse marquée
    // PAR DÉFAUT, ou la seule disponible s'il n'y en a qu'une. Jamais un choix
    // arbitraire parmi plusieurs — dans ce cas on ne propose rien et l'écran
    // affiche l'avertissement. Remplace l'ancien `options[0]`.
    proposeAddressOption (options) {
      if (!options || !options.length) return null
      const def = options.find(o => o && (o.isdefault === true || o.isdefault === 'true'))
      if (def) return def
      return options.length === 1 ? options[0] : null
    },

    _beginAddressLoading () {
      this.addressLoadPending++
      this.addressesLoading = true
    },
    _endAddressLoading () {
      this.addressLoadPending = Math.max(0, this.addressLoadPending - 1)
      if (this.addressLoadPending === 0) this.addressesLoading = false
    },

    // Libellé de la première option, ou "". Un contact sans aucune adresse
    // donnait `options[0].label` => TypeError, qui interrompait au passage le
    // chargement du template de bas de mail.
    _firstAddressLabel (list) {
      const first = Array.isArray(list) && list.length ? list[0] : null
      return first && typeof first.label === 'string' ? first.label : ''
    },

    // Raison de refuser un enregistrement, ou null. Prête à notifier.
    addressSaveBlockReason () {
      if (this.addressesLoading) return 'Addresses are still loading. Please try again in a moment.'
      return null
    }
  }
}
